import React, { useState, useEffect, useMemo } from 'react'
import { isEmpty, isEqual } from 'lodash'
import { renderField } from '../utils'
import {
  ANALYSIS_MODE,
  CHART_DEFINITION_FIELDS
} from '../../chartConfigurationsV2'


export const DataStreamCard = ({
  streams = {},
  onChangeValue = () => null,
  onStreamsChange = () => null,
  onChange = () => { },
  selectedTableName = '',
  metricData = [],
  workspace,
  chartValues,
  hideAnalysisMode = false,
  color = ''
}) => {
  const handleStreamChange = (updatedStream) => {
    let updatedStreams = {
      ...streams,
      ...updatedStream
    }

    onChange(updatedStreams)
  }

  return (
    <div className='chart-editor-data-streams'>
      <Stream
        key={1}
        index={0}
        chartValues={chartValues}
        streamValues={streams}
        selectedTableName={selectedTableName}
        metricData={metricData}
        onChange={(updated) => handleStreamChange(updated)}
        workspace={workspace}
        hideAnalysisMode={hideAnalysisMode}
        color={color}
      />
    </div>
  )
}

export const Stream = (props = {
  index: null,
  streamValues: null,
  selectedTableName: '',
  metricData: [],
  onChange: () => null,
  workspace,
  hideAnalysisMode: false,
  color: ''
}) => {
  const { index, streamValues, selectedTableName, metricData, onChange, workspace, hideAnalysisMode, chartValues, color } = props

  const [currentStreamValues, setCurrentStreamValues] = useState({ ...streamValues })

  useEffect(() => {
    setCurrentStreamValues({ ...streamValues })
  }, [streamValues])

  // Conditionally include analysisMode based on hideAnalysisMode prop
  const baseFields = hideAnalysisMode ? ['streamLabel'] : ['streamLabel', 'analysisMode']
  const analysisFields = (ANALYSIS_MODE[currentStreamValues.analysisMode]?.fields || [])
  const fields = [...baseFields, ...analysisFields]

  const handleFieldChange = (fieldId, value) => {
    const updatedStreamValues = {
      ...currentStreamValues,
      [fieldId]: value
    }

    setCurrentStreamValues(updatedStreamValues)

    onChange(updatedStreamValues)
  }

  return (
    <>
      {fields.map((fieldId, index) => {
        return renderField(fieldId, CHART_DEFINITION_FIELDS, [], currentStreamValues, {
          ...props,
          onChangeField: handleFieldChange
        })
      })}
    </>
  )
}